import React from 'react';
import banner from '../../../assets/images/banner.png';
import './Banner.css';
import SocialMedia from '../../Shared/SocialMedia/SocialMedia';
import Download from '../Download/Download';

const Banner = () => {
    return (
        <div className='mt-16'>
            <div className='h-60 flex justify-center rounded'>
                <img src= {banner} alt="" />
            </div>

            <section>
                <div className='text-center'>
                    <h2 className='text-5xl my-2'>Hi, I am <span className='text-orange-400 font-semibold'>Merazur Rahman</span> </h2>
                    <p className='text-xl'>I am a frontend web developer. And focused on MERN Stack Web Development. <br /> I can provide clean code and pixel perfect design. I also make website more & more interactive with web animations.</p>
                </div>
            </section>

            <section>
                <SocialMedia></SocialMedia>
                <div className='text-center'>
                <Download></Download>
                </div>
            </section>


            
        </div>
    );
};

export default Banner;